import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ruTranslation from './locales/ru.json';
import roTranslation from './locales/ro.json';
import enTranslation from './locales/en.json';
import landingRo from './locales/landing-ro.json';
import landingRu from './locales/landing-ru.json';
import landingEn from './locales/landing-en.json';

declare global {
  interface Window {
    i18next: typeof i18n;
  }
}

const LANGUAGE_KEY = 'selectedLanguage';

const SUPPORTED = ['ro', 'ru', 'en'] as const;
type SupportedLang = (typeof SUPPORTED)[number];

function isSupportedLang(code: string | null | undefined): code is SupportedLang {
  return Boolean(code && (SUPPORTED as readonly string[]).includes(code));
}

function matchBrowserToSupported(raw: string): SupportedLang | null {
  const base = raw.split('-')[0].toLowerCase();
  return isSupportedLang(base) ? base : null;
}

function getInitialLanguage(): SupportedLang {
  if (typeof window === 'undefined') return 'ro';

  try {
    const stored = localStorage.getItem(LANGUAGE_KEY);
    if (isSupportedLang(stored)) return stored;
  } catch {
    // ignore
  }

  const candidates = [
    ...(typeof navigator !== 'undefined' ? navigator.languages || [] : []),
    typeof navigator !== 'undefined' ? navigator.language : '',
  ];
  for (const raw of candidates) {
    const hit = matchBrowserToSupported(raw);
    if (hit) return hit;
  }

  return 'ro';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: { ...ruTranslation, landing: landingRu } },
      ro: { translation: { ...roTranslation, landing: landingRo } },
      en: { translation: { ...enTranslation, landing: landingEn } },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'ro',
    interpolation: {
      escapeValue: false,
    }
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LANGUAGE_KEY, lng);
});

window.i18next = i18n;

export default i18n;
